import { DoctorSimple } from '@dreryk/egabinet-personnel-frontend-api';
import { PractitionerId } from '@dreryk/egabinet-personnel-published-language-api';

export const resolvePractitionerIdsQueryValue = (
   practitionerIds: PractitionerId[],
   currentDoctor: DoctorSimple | null,
   doctors: DoctorSimple[],
   applyCurrentDoctorFilter: boolean
): PractitionerId[] => {
   if (practitionerIds.length) {
      return practitionerIds.map(Number).map((id) => PractitionerId.of(id));
   }

   if (applyCurrentDoctorFilter && currentDoctor) {
      return [PractitionerId.of(currentDoctor.practitionerId)];
   }

   if (doctors.length) {
      return doctors.map(({ practitionerId }) => PractitionerId.of(practitionerId));
   }

   return [];
};
